import { useMemo } from "react";
import DOMPurify from "dompurify";

/**
 * Hook to sanitize HTML and make links safe for React components.
 * @param html The HTML string to sanitize
 * @returns Object suitable for dangerouslySetInnerHTML
 */
export function useSanitizedHTML(html: string) {
  const sanitizedHTML = useMemo(() => {
    if (!html) {
      return "";
    }

    // Sanitize with DOMPurify
    const cleanHTML = DOMPurify.sanitize(html);

    // Transform links to open in a new tab safely
    const div = document.createElement("div");
    div.innerHTML = cleanHTML;

    div.querySelectorAll("a").forEach((link) => {
      link.setAttribute("target", "_blank");
      link.setAttribute("rel", "noopener noreferrer");
    });

    return div.innerHTML;
  }, [html]);

  // Return ready-to-use object for dangerouslySetInnerHTML
  return useMemo(() => ({ __html: sanitizedHTML }), [sanitizedHTML]);
}
